import React from 'react';
import brandLaunchEvent01 from '../../assets/images/event/brand_launch_event/brand_launch_event_01.png';
import brandLaunchEvent02 from '../../assets/images/event/brand_launch_event/brand_launch_event_02.png';
import brandLaunchEvent03 from '../../assets/images/event/brand_launch_event/brand_launch_event_03.png';
import brandLaunchEvent04 from '../../assets/images/event/brand_launch_event/brand_launch_event_04.png';
import brandLaunchEvent05 from '../../assets/images/event/brand_launch_event/brand_launch_event_05.png';

const BrandLaunchEventPage: React.FC = () => {
  const eventImages = [
    brandLaunchEvent01,
    brandLaunchEvent02,
    brandLaunchEvent03,
    brandLaunchEvent04,
    brandLaunchEvent05
  ];

  return (
    <div className="max-w-4xl mx-auto">
      {eventImages.map((imageSrc, index) => (
        <div key={index} className="flex justify-center">
          <img
            src={imageSrc}
            alt={`브랜드 런칭 이벤트 ${index + 1}`}
            className="max-w-full h-auto"
          />
        </div>
      ))}
    </div>
  );
};

export default BrandLaunchEventPage;
